<template>
  <div id="app">
    <div class="clearfix c-header">
      <div class="contain">
        <div class="logo">
            <img :src="require('./assets/logo.png')" alt="">
        </div>
        <div class="tabbar">
<!--           <router-link to="/home">
            联盟首页
          </router-link> -->
          <router-link to="/medianav/web">
            网站联盟中心
          </router-link>
          <router-link to="/medianav/mobile">
            移动联盟中心
          </router-link>
          <a href='http://tiyan.adyun.com' target="_blank">
            推广体验中心
          </a>
          <a href='http://ssp.adyun.com/Passport/register' target="_blank">
            媒介合作
          </a>
          <div class="clearBoth"></div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import footerNav from './components/widget/footer/footer'

export default {
  name: 'app',
  components: {
    footerNav
  },
  mounted () {
    let a = [0]
    let b = a.reduce((previousValue, currentValue, index, array) => {
      console.log(previousValue, currentValue, index)
      return previousValue + currentValue
    })
    console.log(b)
  }
}
</script>

<style lang='less'>
@import './css/common';
@import './css/fonts';
#app {
  .logo{
    position: absolute;
    top: 10px;
  }
  .c-header{
    height: 60px;
    background-color: #1A1C27;
  }
  .tabbar{
    width: 50%;
    float:right;
    height: 30px;
    position: absolute;
    top: 15px;
    right: 0;
    a{
      text-align: center;
      height: inherit;
      line-height: 28px;
      height: 30px;
      text-decoration: none;
      float: left;
      color: white;
      padding: 2px 25px;
      display: block;
      &.router-link-active{
        color: @theme;
      }
    }
    a+a{
      margin-left: 30px;
    }
    a:nth-child(3){
      border-radius: 25px;
      background-color: @theme;
    }
    a:nth-child(4){
      border-radius: 25px;
      background-color: @theme;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?de665b30